var map = {
	"./c1.png": 70187,
	"./c2.png": 9542,
	"./c3.png": 23533,
	"./c4.png": 14076,
	"./c5.png": 91332,
	"./c6.png": 94887,
	"./c7.png": 79463,
	"./c8.png": 82785,
	"./f1.png": 16891,
	"./f2.png": 76006,
	"./f3.png": 27441,
	"./f4.png": 19536,
	"./f5.png": 63767,
	"./f6.png": 51636
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71041;